"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

var _industry = _interopRequireDefault(require("../options/industry.json"));

var _body = _interopRequireDefault(require("../options/body.json"));

var _degree = _interopRequireDefault(require("../options/degree.json"));

var _disease = _interopRequireDefault(require("../options/disease.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Options


var batteryId = _utils.screeners.RTWDEMOG;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "",
  inline: true
};
var demographicQuestions = [{
  prompt: "What is your age?",
  extraText: "",
  units: "years",
  type: "text",
  optional: false,
  key: "age",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "What is your gender?",
  type: "radio",
  options: ["Male", "Female", "Other", "Prefer not to say"],
  key: "gender",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "What is the highest degree or level of school you have completed?",
  extraText: "",
  type: "dropdown",
  options: _degree["default"],
  optional: false,
  key: "degree",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "Which industry do you work in?",
  extraText: "",
  type: "dropdown",
  options: _industry["default"],
  optional: false,
  key: "industry",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "What is your role?",
  extraText: "",
  type: "text",
  optional: false,
  key: "role",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "What injury or disease did you experience related to this claim? (If you have several, please list the primary injury or disease)",
  extraText: "",
  type: "dropdown",
  options: _disease["default"],
  optional: false,
  key: "disease",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "Which area of the body did your primary injury or disease occur to for this claim?",
  extraText: "",
  type: "dropdown",
  options: _body["default"],
  optional: false,
  key: "body",
  eval: function _eval(n, q) {
    return q.options[n];
  }
}];
var questions = (0, _utils.wrapBattery)(demographicQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    RTWDEMOG: score,
    RTWDEMOG_1: answers[0],
    RTWDEMOG_2: answers[1],
    RTWDEMOG_3: answers[2],
    RTWDEMOG_4: answers[3],
    RTWDEMOG_5: answers[4],
    RTWDEMOG_6: answers[5],
    RTWDEMOG_7: answers[6],
    RTWDEMOG_8: answers[7]
  };
}